import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/site';
const ABOUT_HEADING_SRC = 'https://cdn.magicpatterns.com/uploads/x7BC2mWkzcUyqyPL8PpVH8/black-comet-labs-about-heading-v4.png';
export function LabFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-ink/10 bg-cream py-20 md:py-28" data-id="element-116" data-mp="137a5lpklqr27">
      <div className="mx-auto max-w-content px-5 md:px-8 lg:px-10" data-id="element-117" data-mp="6icb88grkv5k">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-118" data-mp="bgnl2j7275ns">
          <div className="lg:col-span-4" data-id="element-119" data-mp="bejiq5ot6epm">
            <h2 data-id="element-120" data-mp="fhzb2ptuhswi">
              <span className="sr-only" data-id="element-121" data-mp="fhfsd6wdf0hf">About the lab</span>
              {/* Final approved artwork, rendered directly — its own cream
                  ground matches the section, so no filter or mask is applied. */}
              <span className="block w-[215px] md:w-[260px]" data-id="element-122" data-mp="3jw77ozd85ptv">
                {/* darken (channel minimum) lets the cream canvas replace the
                    artwork's lighter ground while keeping the violet and ink. */}
                <img src={ABOUT_HEADING_SRC} alt="" className="h-auto w-full mix-blend-darken" data-id="element-123" data-mp="2mu3wbyjkon1i" />
              </span>
            </h2>
          </div>

          <div className="lg:col-span-8" data-id="element-124" data-mp="283o8ebzrv0zn">
            <ul className="border-t border-ink/15" data-id="element-125" data-mp="282vck62cpvwa">
              {faqs.map((faq, index) => {
              const open = openIndex === index;
              const panelId = `faq-panel-${index}`;
              const buttonId = `faq-button-${index}`;
              return <li key={faq.question} className="border-b border-ink/15" data-id="element-126" data-mp="1u4omvd7k327p" data-mpi={index}>
                    <h3 data-id="element-127" data-mp="1p52992ntfjyd">
                      <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenIndex(open ? null : index)} className="flex w-full items-center justify-between gap-6 py-6 text-left" data-id="element-128" data-mp="1p5kayet8yqdo">
                        <span className="font-display text-[20px] font-medium leading-snug text-ink md:text-[24px]" data-id="element-129" data-mp="1ml5vaik8y0ni">
                          {faq.question}
                        </span>
                        <span className="flex h-9 w-9 shrink-0 items-center justify-center border border-ink/20 text-ink" data-id="element-130" data-mp="1cti1ib07w7iv">
                          {open ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-131" data-mp="20i14qc4etu43" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-132" data-mp="1qly6viglchmy" />}
                        </span>
                      </button>
                    </h3>
                    <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!open} className="pb-7 pr-12" data-id="element-133" data-mp="f6iy7hf0s1c0">
                      <p className="max-w-2xl text-[16px] leading-relaxed text-ink/70" data-id="element-134" data-mp="2yc3k5u26bsgf">
                        {faq.answer}
                      </p>
                    </div>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}